(function () {
  'use strict';

  function LostPasswordCtrl($scope, $location, $state, $http, Configuration) {
    $scope.step = 1;

    const tokenFromQuery = $location.search().reset_password_token;
    const tokenFromHash = ($location.hash().match(/(?:^|&)reset_password_token=([^&]+)/) || [])[1];
    const token = tokenFromQuery || (tokenFromHash && decodeURIComponent(tokenFromHash));

    if (token) {
      $scope.token = token;
      $scope.step = 2;
      // Strip token from URL without re-entering the state (which would re-run this controller without the token)
      if (tokenFromHash) {
        $location.hash('').replace();
      }
      $state.transitionTo($state.current, { reset_password_token: null }, {
        reload: false,
        location: 'replace',
        inherit: false,
        notify: false
      });
    }

    $scope.resetPassword = function (email) {
      $scope.processing = true
      $http
        .post(`${Configuration.apiUrl}/users/reset_password`, { email: email })
        .then(function () {
          $scope.displayCheckEmail = true
          $scope.email = ''
        })
        .catch(function (err) {
          console.log(err)
        })
        .finally(function () {
          $scope.processing = false
        })
    };

    $scope.data = {
      password: '',
      repeatPassword: ''
    };
    $scope.confirmPasswordReset = function (token, password) {
      $scope.processing = true;
      $http
        .put(`${Configuration.apiUrl}/users/reset_password`, { token: token, password: password })
        .then(function () {
          $scope.success = true
          $scope.data.password = ''
          $scope.data.repeatPassword = ''
        })
        .catch(function (err) {
          $scope.error = err
        })
        .finally(function () {
          $scope.processing = false
        })
    };
  }

  app.controller('LostPasswordCtrl', ['$scope', '$location', '$state', '$http', 'Configuration', LostPasswordCtrl]);
})();
